import { create } from 'zustand';
import { getDefaultTimeInterval } from '@src/shared/utils';

interface IUserInfo {
  api_key?: string;
  customer_enabled?: boolean;
  customer_id?: number;
  customer_name?: string;
  hidden?: boolean;
  instant_filter_enabled?: number;
  is_selected?: boolean;
  primary?: boolean;
  profile_id?: number;
  role?: string;
  timezone: number;
  tzName?: string;
  username?: string;
  can_use_preview?: boolean;
  is_tlb2?: boolean;
  data_access_months?: number;
  activation_creator_enabled?: boolean;
  eco_activation_flow?: boolean;
  is_new_workflow?: boolean;
  eco_new_data_model?: boolean;
  app_spi?: boolean;
  flow_network_request_recommendation?: boolean;
  eco_activation_flow_suggestion?: boolean;
  feature_flags?: Record<string, boolean>;
}

interface ICommonStore {
  userInfo: IUserInfo;
  setUserInfo: (userInfo: IUserInfo) => void;
  timeRange: [string, string];
  setTimeRange: (timeRange: [string, string]) => void;
  predefinedMappedEvents: any[];
  setPredefinedMappedEvents: (predefinedMappedEvents: any[]) => void;
  metadata: any[];
  setMetadata: (metadata: any[]) => void;
  defaultInterval: [string, string];
}

export const useCommonInfoStore = create<ICommonStore>((set) => ({
  userInfo: {},
  setUserInfo: (userInfo: IUserInfo) => set({ userInfo }),
  timeRange: [],
  setTimeRange: (timeRange: [string, string]) => {
    set({ timeRange, defaultInterval: getDefaultTimeInterval(timeRange) });
  },
  predefinedMappedEvents: [],
  setPredefinedMappedEvents: (predefinedMappedEvents: any[]) => set({ predefinedMappedEvents }),
  metadata: [],
  setMetadata: (metadata: any[]) => set({ metadata }),
  defaultInterval: ['', ''] as [string, string],
}));
